import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { yihangTheme } from '@yihang/ui/theme'
import '@yihang/ui/styles.css'
import AntdApp from 'antd/es/app'
import ConfigProvider from 'antd/es/config-provider'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { AppStateProvider } from './state/app-state'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 30_000 },
    mutations: { retry: 0 },
  },
})

const root = document.getElementById('root')

if (!root) throw new Error('Missing root element')

createRoot(root).render(
  <StrictMode>
    <ConfigProvider theme={yihangTheme}>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <AppStateProvider>
            <RouterProvider router={router} />
          </AppStateProvider>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
)
